'use client'

import { createContext, type ReactNode, useContext } from 'react'

const FALLBACK_MOBILE_COUNTRY_CODE = '966'

const DefaultMobileCountryCodeContext = createContext<string>(FALLBACK_MOBILE_COUNTRY_CODE)

interface DefaultMobileCountryCodeProviderProps {
    children: ReactNode
    defaultMobileCountryCode?: string
}

export const DefaultMobileCountryCodeProvider = ({
    children,
    defaultMobileCountryCode
}: DefaultMobileCountryCodeProviderProps) => (
    <DefaultMobileCountryCodeContext.Provider value={defaultMobileCountryCode || FALLBACK_MOBILE_COUNTRY_CODE}>
        {children}
    </DefaultMobileCountryCodeContext.Provider>
)

export const useDefaultMobileCountryCode = () => useContext(DefaultMobileCountryCodeContext)
